<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('tab.inventoryLimit')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="data" :rules="rules" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemNo')">
            <vxe-input v-model="data.item.no" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.itemName')">
            <vxe-input v-model="data.item.name" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.storageRoom')" prop="storageRoom.name">
            <vxe-input v-model="data.storageRoom.name" :editable="false" style="width: 100%" @click="onStorageRoomSelect"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.upperBound')" prop="upperBound">
            <vxe-number-input v-model="data.upperBound" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.lowerBound')" prop="lowerBound">
            <vxe-number-input v-model="data.lowerBound" :min="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
  </vxe-modal>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { findOne, save } from '@/api/Api'
import { InventoryLimit } from '@/api/dto/config/InventoryLimit'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'

export default {
  name: 'InventoryLimitEditor',
  components: { StorageRoomModal },
  data() {
    return {
      visible: false,
      loading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      data: new InventoryLimit(),
      rules: {
        'storageRoom.name': [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        upperBound: [{ required: true, message: this.$t('message.canNotBeEmpty'), min: 0, type: 'number' }],
        lowerBound: [{ required: true, message: this.$t('message.canNotBeEmpty'), min: 0, type: 'number' }]
      }
    }
  },
  methods: {
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(value) {
      this.data.storageRoom = new StorageRoom(value[0])
    },
    add(item) {
      this.visible = true
      this.data = new InventoryLimit()
      this.data.item = item
      this.data.approved = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('inventoryLimitFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new InventoryLimit(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      data.warehouse = this.warehouse
      save('inventoryLimitPersister', data).then(res => {
        if (res.success) {
          this.data = new InventoryLimit(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    }
  }
}
</script>